import { motion } from "framer-motion";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";
import { useLang, CONTACT, ASSETS } from "../i18n";

export const Contact = () => {
  const { t } = useLang();
  const items = [
    { icon: Phone, label: t.contact.phone, value: CONTACT.phone, href: CONTACT.phoneHref },
    { icon: Mail, label: t.contact.email, value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: Instagram, label: t.contact.insta, value: CONTACT.instagram, href: CONTACT.instagramHref },
    { icon: MapPin, label: t.contact.zone, value: t.contact.zoneValue, href: null },
  ];
  const wa = `https://wa.me/41765787914`;

  return (
    <section id="contact" className="relative py-28 md:py-36 bg-[var(--c-bg)] overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_50%,rgba(122,16,16,0.3),transparent_55%)]" />
      <img src={ASSETS.mercedes} alt="" className="pointer-events-none absolute -right-20 bottom-0 w-1/2 opacity-10 hidden lg:block" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[var(--c-gold)]" />
              <span className="overline">{t.contact.tag}</span>
            </div>
            <h2 className="font-display text-5xl sm:text-6xl font-semibold text-white leading-[0.95]">
              {t.contact.title}
            </h2>
            <p className="mt-6 text-neutral-400 text-lg max-w-md">{t.contact.sub}</p>
            <a
              data-testid="contact-whatsapp"
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-9 inline-flex items-center gap-2 bg-[var(--c-gold)] text-black font-semibold px-7 py-3.5 rounded-full hover:bg-[var(--c-gold-soft)] transition-colors"
            >
              <Phone size={18} /> {t.contact.cta}
            </a>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-4">
            {items.map((it, i) => {
              const Wrapper = it.href ? "a" : "div";
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                >
                  <Wrapper
                    {...(it.href ? { href: it.href, target: "_blank", rel: "noopener noreferrer" } : {})}
                    data-testid={`contact-item-${i}`}
                    className="hover-lift block rounded-2xl p-6 bg-[var(--c-bg-3)] gold-border h-full"
                  >
                    <div className="w-11 h-11 rounded-xl bg-[var(--c-gold)]/10 flex items-center justify-center mb-4">
                      <it.icon size={20} className="text-[var(--c-gold)]" />
                    </div>
                    <p className="font-mono text-[0.6rem] uppercase tracking-widest text-neutral-500 mb-1.5">
                      {it.label}
                    </p>
                    <p className="text-white text-sm leading-snug">{it.value}</p>
                  </Wrapper>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
